import { Feedback, ValidatorFeedback } from '../Interface/ValidatorFeedback';
import { post } from './ApiService';
import { ServiceContainer } from './ServiceContainer/ServiceContainer';

export const postValidatorFeedback = async (feedback: ValidatorFeedback): Promise<void> => {
    return post<void>('v1/validator/feedback', JSON.stringify(feedback));
};

export const postInterestFeedback = async (feedback: Feedback): Promise<void> => {
    const { storeGateway } = ServiceContainer;
    return post<void>('v1/filter/feedback', JSON.stringify(feedback), storeGateway.getState().auth.token);
};
